export default "__VITE_ASSET__CYe6CfIk__"